<template>
  <div class="top-bar ellipsis">
    <span class="top-bar-icon" @click="goBack">
      <i class="icon-back"></i>
    </span>
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'TopBar',
  methods: {
    goBack() {
      window.history.length === 1 ? this.$router.push('/help-center/') : this.$router.go(-1);
    }
  }
}
</script>
<style lang="scss" scoped>
.top-bar {
  padding: 8px 12px 8px 9px;
  line-height: 16px;
  display: flex;
  height: 32px;
  align-items: center;

  &-icon {
    margin-right: 4px;
    width: 15px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    cursor: pointer;

    &:hover {
      background: var(--current-bg-hover-color);
    }
    
    > i {
      font-size: 14px;
      color: var(--current-default-color);
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/top-bar/index.vue